var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownLargeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 29,
    viewBox: "0 0 18 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7889 20.4782L9.43943 28.6519C9.23781 28.8946 8.87764 28.9279 8.63497 28.7264C8.60797 28.7039 8.58299 28.679 8.56053 28.6519L0.211055 20.4782C-0.0559199 20.2307 -0.0717329 19.8136 0.175728 19.5466C0.298448 19.4142 0.470039 19.3379 0.650545 19.3356L4.60554 19.3356L4.60554 8.74489C4.68057 8.30229 5.03855 7.96222 5.48444 7.9099L12.5156 7.9099C12.8672 7.9099 12.955 8.34931 12.955 8.74489L12.955 19.3356L17.3495 19.3356C17.7135 19.3404 18.0047 19.6393 17.9999 20.0033C17.9976 20.1838 17.9213 20.3554 17.7889 20.4782Z",
    fill: "#EE6055"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5224 6.59155L5.49122 6.59155C5.12718 6.59155 4.83203 6.2964 4.83203 5.93236C4.83203 5.56832 5.12718 5.27316 5.49122 5.27316L12.5224 5.27317C12.8864 5.27317 13.1816 5.56832 13.1816 5.93236C13.1816 6.2964 12.8865 6.59155 12.5224 6.59155Z",
    fill: "#EE6055"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5224 3.95508L5.49122 3.95508C5.12718 3.95508 4.83203 3.65993 4.83203 3.29588C4.83203 2.93184 5.12718 2.63669 5.49122 2.63669L12.5224 2.63669C12.8864 2.63669 13.1816 2.93184 13.1816 3.29589C13.1816 3.65993 12.8865 3.95508 12.5224 3.95508Z",
    fill: "#EE6055"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5224 1.31836L5.49122 1.31836C5.12718 1.31836 4.83203 1.02321 4.83203 0.659165C4.83203 0.295124 5.12718 -2.60552e-05 5.49122 -2.59916e-05L12.5224 -2.47622e-05C12.8864 -2.46986e-05 13.1816 0.295126 13.1816 0.659167C13.1816 1.02321 12.8865 1.31836 12.5224 1.31836Z",
    fill: "#EE6055"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownLargeIcon);
export default __webpack_public_path__ + "static/media/ArrowDownLargeIcon.d6684113f6975b1107f69d98190b9dc3.svg";
export { ForwardRef as ReactComponent };